import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Modal, Tabs, Tab, FooterButton } from 'Core/components'; 
import { showToast } from 'Core/redux/toast/slice';
import CustomPropTypes from 'Core/prop-types';
import { addInventory, editInventory } from './store/slice';
import { AppModal } from '../components/app-modals';
import { InventoryService } from '../../service/api/inventory-service';
import ToastService from '../../service/toast-service';
import InventorySerialNumberTable from './inventory-serialnumber-table';

import InventorySerialFilter from './inventory-serial-filter';
import { selectStatuses } from 'Core/redux/status/selectors';
import { useTransformOptions } from 'Core/hooks';
import { fetchStatuses } from '../../core/redux/status/slice';
import { selectFilteredInventoryDetail } from './store/selectors';

const InventoryAddEdit = ({ showModal, modalData, onCloseModal }) => {
 
  const dispatch = useDispatch();
  const inventoryData = useSelector(selectFilteredInventoryDetail);//modalData;
  

  const [formData, setFormData] = useState(inventoryData || null);
  const [partsData, setPartsData] = useState(inventoryData?.parts || []);
  const [pickTicketsData, setPickTicketsData] = useState(inventoryData?.inventoryPickTickets || []);
  const [filesData, setFilesData] = useState(inventoryData?.shippingDocuments || []);
  let isEditMode = Boolean(inventoryData?.partId);
  useEffect(() => {
    setFormData(inventoryData || null);
    setPartsData(inventoryData?.parts || []);
    setPickTicketsData(inventoryData?.inventoryPickTickets || []);
    setFilesData(inventoryData?.shippingDocuments || []);
    
  },[inventoryData])

  const [loading, setLoading] = useState(true);
  const [showToast, setShowToast] = useState(false);
  const [currentToast, setCurrentToast] = useState(null);

  

  const statuses = useSelector(selectStatuses);
  const statusesOptions = useTransformOptions(statuses, 'status', 'status', '', 'Select Status');

  const onChangesInventoryForm = data => {
    setFormData(data);
  };

  const onChangesParts = data => {
    setPartsData(data);
  };

  const onChangesFiles = data => {
    setFilesData(data);
  };

  const onChangesPickTickets = data => {
    setPickTicketsData(data);
  };

  const handleClose = () => {
    onCloseModal();
  };

  const body = () => {
    return (
      <div className="row">
        <br></br>
        <InventorySerialFilter />
        <InventorySerialNumberTable data={partsData} />
      </div>
    );
  };

  const valid = () => {
    if (
      formData?.customerId === '' ||
      formData?.status === '' ||
      partsData?.length === 0 ||
      filesData?.length === 0
    ) {
      dispatch(
        showToast({
          message: 'Please fill all required fields',
          type: 'danger',
        }),
      );
      return false;
    }
    return true;
  };

  const footer = () => {
      
  };

  return (
    <Modal
      id="inventory-modal"
      show={showModal}
      dialogClassName="modal-90w"
      size="xl"
      title={isEditMode ? `Inventory Details (Part Number: ${inventoryData.partNumber})` : 'Add Inventory'}
      body={body}
      footer={footer}
      handleClose={handleClose}
    />
  );
};

InventoryAddEdit.propTypes = {
  showModal: PropTypes.bool,
  modalData: PropTypes.shape(CustomPropTypes.Inventory),
  onCloseModal: PropTypes.func,
};

export default AppModal(InventoryAddEdit);
